import React from 'react'
import NotebookIcon from './NotebookIcon'
import GoodIcon from './GoodIcon'
import BadIcon from './BadIcon'
import FeedbackIcon from './FeedbackIcon'
import '../css/ChatAreaUnderbar.css'; // 必要に応じてCSSをインポート


const ChatUnderbarArea = ({ isGood, isBad, feedback, chatHistoryId, onSaveClick, onGoodClick, onBadClick, onFeedbackClick, userMessage, assistantMessage }) => {
  return (
    <div className="feedback">
      <NotebookIcon chatHistoryId={chatHistoryId} onClick={onSaveClick} />
      <GoodIcon isGood={ isGood } chatHistoryId={chatHistoryId} onClick={onGoodClick} />
      <BadIcon isBad={ isBad } chatHistoryId={chatHistoryId} onClick={onBadClick} />
      {/* <FeedbackIcon feedback={ feedback } onClick={onFeedbackClick} /> */}
    </div>
  )
}

export default ChatUnderbarArea